var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0229 42.3359H39.9785C40.4975 42.3358 41.0076 42.2011 41.459 41.9449C41.9104 41.6887 42.2875 41.3197 42.5536 40.8741C42.8198 40.4285 42.9657 39.9215 42.9772 39.4026C42.9888 38.8837 42.8655 38.3707 42.6195 37.9137L26.6426 8.24187C25.5091 6.13812 22.4923 6.13812 21.3588 8.24187L5.38196 37.9137C5.13592 38.3707 5.01264 38.8837 5.02418 39.4026C5.03572 39.9215 5.18167 40.4285 5.44778 40.8741C5.7139 41.3197 6.09106 41.6887 6.54242 41.9449C6.99378 42.2011 7.50389 42.3358 8.0229 42.3359Z",
    stroke: "#F6B51C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4613 18.8176L23.9994 30.2551L24.5366 18.8223C24.5399 18.7492 24.5283 18.6762 24.5025 18.6078C24.4766 18.5393 24.4371 18.4769 24.3863 18.4242C24.3355 18.3716 24.2745 18.3298 24.207 18.3016C24.1395 18.2733 24.067 18.2591 23.9938 18.2598C23.9219 18.2605 23.8509 18.2756 23.785 18.3042C23.719 18.3328 23.6595 18.3743 23.6098 18.4263C23.5602 18.4783 23.5215 18.5397 23.496 18.6069C23.4705 18.6741 23.4587 18.7458 23.4613 18.8176Z",
    stroke: "#F6B51C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.7422C23.6292 37.7422 23.2666 37.6322 22.9583 37.4262C22.65 37.2202 22.4096 36.9273 22.2677 36.5847C22.1258 36.2421 22.0887 35.8651 22.161 35.5014C22.2334 35.1377 22.412 34.8036 22.6742 34.5414C22.9364 34.2791 23.2705 34.1006 23.6342 34.0282C23.9979 33.9559 24.3749 33.993 24.7175 34.1349C25.0601 34.2768 25.353 34.5171 25.559 34.8255C25.765 35.1338 25.875 35.4963 25.875 35.8672C25.875 36.3645 25.6775 36.8414 25.3258 37.193C24.9742 37.5446 24.4973 37.7422 24 37.7422Z",
    fill: "#F6B51C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonWarning);
export default __webpack_public_path__ + "static/media/IonWarning.b07837aafef5e12e719a31c73451c0be.svg";
export { ForwardRef as ReactComponent };